module.exports = __webpack_public_path__ + "1b92bead69bbca7ba1abe0a6866c4aed.svg";